export const CONTEST_TERRITORIES_OPTIONS = [
  "regionName",
  "name",
  "startDate",
  "endDate",
  "status",
];
